import styled from 'styled-components';

import {grey} from '@drivesally/sally-ui/lib/libs/colors';

const Section = styled.div`
  border-bottom: 1px solid ${grey};
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;

  &:last-child {
    border-bottom: none;
  }
`;

export default Section;
